import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '../store/core.state';
import { authLogout } from '../store/auth/auth.actions';
import { RolesArcgisLoadFailureAction } from 'src/app/features/store/entities/shared/roles-arcgis/roles-arcgis.actions';

@Injectable()
export class GxErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store<AppState>) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          let result = null;
          for (const key of ['queryResults', 'addResults', 'updateResults', 'deleteResults']) {
            if (key in event.body) {
              result = event.body[key];
            }
          }
          if (result && !result.success && result.error && result.error.code !==1) {
            const error = result.error;
            let status = 500;
            switch (error.code) {
              case 150:
                status = 404;
                this.store.dispatch(authLogout());
                break;
              case 1:
                this.store.dispatch(new RolesArcgisLoadFailureAction(error))
                break;
            }

            throw new HttpErrorResponse({
              error: error.description,
              headers: event.headers,
              status,
              statusText: error.description,
              url: event.url,
            });
          }
        }
        return event;
      })
    );
  }
}
